import React, { useState } from 'react';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="w-full max-w-5xl px-4 mx-auto mt-2 relative z-50">
      <div className="flex items-center justify-between h-16 w-full">
        
        {/* BAGIAN KIRI: LOGO */}
        <div className="flex-shrink-0">
          <a className="flex items-center group cursor-pointer" href="/">
            <div className="relative">
              <img 
                alt="Logo" 
                className="w-auto h-10 rounded-lg transition-all duration-300 group-hover:scale-110 object-contain" 
                src="/logo.png" 
                style={{ filter: 'drop-shadow(rgba(0, 255, 153, 0.3) 0px 0px 8px)' }} 
              />
            </div>
          </a>
        </div>

        {/* BAGIAN TENGAH: MENU DESKTOP (Hanya Pajangan) */}
        <div className="hidden md:flex md:items-center md:space-x-4 ml-8">
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">HOME</span>
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">EMOTION</span>
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">MINDSHARE</span>
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">
            ECOSYSTEM
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><path d="m6 9 6 6 6-6"></path></svg>
          </span>
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">REVENUE</span>
          <span className="px-3 py-2 text-sm font-bold heading-font flex items-center gap-1 rounded-lg text-white/60 cursor-default">COLLECTIBLES</span>
        </div>

        {/* BAGIAN KANAN: LONCENG, TOMBOL CONNECT X, & MENU GARIS TIGA */}
        <div className="flex items-center space-x-3 ml-auto">
          
          <button className="relative p-2 cursor-pointer bg-white/5 hover:bg-white/10 transition-all duration-200 rounded-lg border border-white/10" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-white"><path d="M10.268 21a2 2 0 0 0 3.464 0"></path><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path></svg>
          </button>

          {/* Tombol Connect X (Khusus Desktop) Mengarah ke profil Twitter */}
          <div className="hidden md:block">
            <button 
              onClick={() => window.open('https://x.com/emofi_xyz', '_blank')}
              className="whitespace-nowrap text-sm h-9 px-5 bg-white text-black font-bold rounded-full flex items-center justify-center gap-2 hover:bg-white/90 transition-all duration-200 cursor-pointer"
            >
              Connect to
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></svg>
            </button>
          </div>

          <div 
            className="md:hidden p-2 cursor-pointer bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 transition-all duration-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-white"><path d="M4 12h16"></path><path d="M4 18h16"></path><path d="M4 6h16"></path></svg>
          </div>
        </div>
      </div>

      {/* DROPDOWN MENU KETIKA GARIS TIGA DIKLIK */}
      {isMobileMenuOpen && (
        <div className="absolute top-20 left-4 right-4 md:hidden glass-card p-5 flex flex-col space-y-4 shadow-2xl origin-top animate-in fade-in zoom-in-95 duration-200">
          <span className="text-white/60 heading-font font-bold text-sm cursor-default">HOME</span>
          <span className="text-white/60 heading-font font-bold text-sm cursor-default">EMOTION</span>
          <span className="text-white/60 heading-font font-bold text-sm cursor-default">MINDSHARE</span>
          <span className="text-white/60 heading-font font-bold text-sm flex justify-between items-center cursor-default">
            ECOSYSTEM
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"></path></svg>
          </span>
          <span className="text-white/60 heading-font font-bold text-sm cursor-default">REVENUE</span>
          <span className="text-white/60 heading-font font-bold text-sm cursor-default">COLLECTIBLES</span>
          
          <hr className="border-white/10 my-2" />
          
          {/* Tombol Connect X (Mobile) */}
          <button 
            onClick={() => window.open('https://x.com/emofi_xyz', '_blank')}
            className="w-full whitespace-nowrap text-sm py-3.5 bg-white text-black font-bold rounded-full flex items-center justify-center gap-2 hover:bg-white/90 transition-all duration-200 cursor-pointer"
          >
            Connect to
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></svg>
          </button>
        </div>
      )}
    </nav>
  );
}